module.exports = __webpack_public_path__ + "img/life-float.ea95d8f8.svg";